import React from 'react';

import {observer} from 'mobx-react';
import {StoreIconLink} from "../../../../../core/components/store-icons/store.icon-link";
import {FOOTER_MODULE} from "../footer-module.consts";
import classNames from "classnames";
import styles from "../styles/footer.module.scss";

export const FooterModuleStoreButtons = observer(({controller}) => {
  const {state, device, terms} = controller;
  const {googlePlayUrl, appStoreUrl, isHomePage} = state;
  const {isSmallView} = device;
  const {FOOTER_INSTALL_GOOGLE_ALT, FOOTER_INSTALL_GOOGLE_TITLE, FOOTER_INSTALL_APPLE_ALT, FOOTER_INSTALL_APPLE_TITLE} = terms;

  const width: Number = isSmallView ?  FOOTER_MODULE.LOGOS.STORE.MOBILE.width: FOOTER_MODULE.LOGOS.STORE.DESKTOP.width;
  const height: Number = isSmallView ?  FOOTER_MODULE.LOGOS.STORE.MOBILE.height: FOOTER_MODULE.LOGOS.STORE.DESKTOP.height;

  const baseProps = {
    className: classNames(styles.store_button),
    nofollow: !isHomePage,
    controller,
    width,
    height
  }

  const onClick = (section) => {
    controller.action(FOOTER_MODULE.ACTION_TYPES.storeClick, {section});

    return true;
  };

  const googlePlayProps = {
    alt: FOOTER_INSTALL_GOOGLE_ALT,
    title: FOOTER_INSTALL_GOOGLE_TITLE,
    storeName: FOOTER_MODULE.STORE_NAMES.googlePlay,
    url: googlePlayUrl,
    onClick: () => onClick(FOOTER_MODULE.ANALYTICS.STORES_NAMES.googlePlay),
    ...baseProps
  }

  const appStoreProps = {
    alt: FOOTER_INSTALL_APPLE_ALT,
    title: FOOTER_INSTALL_APPLE_TITLE,
    storeName: FOOTER_MODULE.STORE_NAMES.appStore,
    url: appStoreUrl,
    onClick: () => onClick(FOOTER_MODULE.ANALYTICS.STORES_NAMES.appStore),
    ...baseProps
  }

  return (
    <div className={classNames(styles.store_buttons)}>
      <StoreIconLink {...googlePlayProps} />
      <StoreIconLink {...appStoreProps} />
    </div>
  );
});
